import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import update from 'immutability-helper';
import mutations from '../../graphql/mutations';
import OverlayController from '../overlay/OverlayController';
import { compose } from 'react-apollo';
import './ItemListDefaultTemplate.css';

class ItemListDefaultTemplate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            itemListViewTemplate: {
                type: props.project.itemListViewTemplate.type,
                template: props.project.itemListViewTemplate.template
            }
        };
    }

    onItemListViewTemplateChange(template) {
        this.setState({
            itemListViewTemplate: update(this.state.itemListViewTemplate, {
                template: {$set: template}
            })
        })
    }

    didClickUpdateButton() {
        OverlayController.showActivityIndicator();
        this.props
            .updateItemListViewTemplate(this.props.project.id, this.state.itemListViewTemplate)
            .then(() => {
                OverlayController.hideActivityIndicator();
            })
            .catch((error) => {
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    render() {
        let isCurrentUserAdmin = (this.props.project.aclRole === "admin");
        let updateButtonDisabled = this.state.itemListViewTemplate.template === this.props.project.itemListViewTemplate.template || this.state.itemListViewTemplate.template.length === 0;
        return (
            <div className="itemListDefaultTemplate">
                <TextField
                    className="custom-field custom-multiline-field item-list-view-template-text-field"
                    fullWidth={true}
                    floatingLabelText="Template"
                    floatingLabelFixed={true}
                    value={this.state.itemListViewTemplate.template}
                    inputStyle={{fontFamily: 'monospace'}}
                    hintStyle={{whiteSpace: 'pre', fontFamily: 'monospace'}}
                    hintText={'<div>id: {{id}}</div>\n<div>clientId: {{clientId}}</div>\n<div>created: {{createdAt}}</div>\n<div>updated: {{updatedAt}}</div>'}
                    multiLine={true}
                    rows={4}
                    rowsMax={8}
                    disabled={!isCurrentUserAdmin}
                    onChange={event => this.onItemListViewTemplateChange(event.target.value)}
                />
                <div className="helpLink">for more info visit <a href="https://mustache.github.io/" target="_blank">mustache.github.io</a></div>
                {isCurrentUserAdmin &&
                <RaisedButton
                    className="updateItemListViewTemplateButton"
                    label="Update"
                    primary={true}
                    disabled={updateButtonDisabled}
                    onTouchTap={() => this.didClickUpdateButton()}
                />
                }
            </div>
        );
    }

}

ItemListDefaultTemplate.propTypes = {
    project: PropTypes.object.isRequired
};
ItemListDefaultTemplate.defaultProps = {};

export default compose(
    mutations.updateItemListViewTemplateMutationHoc
)(ItemListDefaultTemplate);



// WEBPACK FOOTER //
// ./src/components/projectSettings/ItemListDefaultTemplate.js